(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["social-videos"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sv-track]').forEach(function (track) {
    var section = track.closest('section');
    var next = section.querySelector('[data-sv-next]');
    if (next) {
      next.addEventListener('click', function () {
        var card = track.querySelector('[data-sv-card]');
        var step = card ? card.offsetWidth + 20 : 320;
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= max - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      });
    }
    var autoplay = track.dataset.autoplay === 'true';
    section.querySelectorAll('[data-sv-card]').forEach(function (card) {
      var video = card.querySelector('video');
      var btn = card.querySelector('[data-sv-play]');
      if (!video || !btn) return;

      if (autoplay) {
        card.classList.add('is-playing');
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (card.dataset.userPaused !== 'true') {
                video.play();
                card.classList.add('is-playing');
              }
            } else {
              video.pause();
              card.classList.remove('is-playing');
            }
          });
        }, { threshold: 0.5 });
        observer.observe(card);
      }

      btn.addEventListener('click', function () {
        if (video.paused) {
          section.querySelectorAll('video').forEach(function (v) {
            if (v !== video) { v.pause(); v.closest('[data-sv-card]').classList.remove('is-playing'); }
          });
          video.play();
          card.classList.add('is-playing');
          card.dataset.userPaused = 'false';
        } else {
          video.pause();
          card.classList.remove('is-playing');
          card.dataset.userPaused = 'true';
        }
      });
      video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
